/**
 * Storage notice state (PECR transparency).
 *
 * The app sets no cookies and no analytics/advertising trackers; it only uses
 * strictly necessary browser storage and storage for features the user asks
 * for. We still show a one-time notice and record that it was seen, together
 * with the policy version, so the notice reappears when the Cookie Policy
 * changes or after 12 months.
 */
export const COOKIE_NOTICE_KEY = "eam_cookie_notice";
// Bump when the Cookie Policy changes in a way users should be told about.
export const COOKIE_NOTICE_VERSION = "2026-10-16";
const MAX_AGE_MS = 365 * 24 * 60 * 60 * 1000;

export function needsCookieNotice() {
  try {
    const raw = localStorage.getItem(COOKIE_NOTICE_KEY);
    if (!raw) return true;
    const { v, at } = JSON.parse(raw);
    if (v !== COOKIE_NOTICE_VERSION) return true;
    return !at || Date.now() - new Date(at).getTime() > MAX_AGE_MS;
  } catch {
    return true;
  }
}

export function acknowledgeCookieNotice() {
  try {
    localStorage.setItem(COOKIE_NOTICE_KEY, JSON.stringify({ v: COOKIE_NOTICE_VERSION, at: new Date().toISOString() }));
  } catch {
    /* storage unavailable (private mode) – the notice will simply show again */
  }
}
